import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "formulario-modelo" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 0,
  class: "vs-wrapper"
}
const _hoisted_4 = { class: "vs-grid" }
const _hoisted_5 = { class: "vs-card vs-card--amarillo" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = { class: "header-flex" }
const _hoisted_8 = {
  key: 0,
  class: "ctx-modelo"
}
const _hoisted_9 = { class: "acciones-header" }
const _hoisted_10 = ["disabled"]
const _hoisted_11 = ["disabled"]
const _hoisted_12 = ["disabled"]
const _hoisted_13 = { class: "filtros-tipo" }
const _hoisted_14 = { class: "marco" }
const _hoisted_15 = { class: "botones" }
const _hoisted_16 = ["disabled"]
const _hoisted_17 = {
  key: 1,
  class: "modal-overlay"
}
const _hoisted_18 = { class: "modal-vs-contenido" }
const _hoisted_19 = { class: "vs-grid" }
const _hoisted_20 = { class: "vs-card vs-card--azul" }
const _hoisted_21 = ["disabled"]
const _hoisted_22 = { class: "vs-card vs-card--amarillo" }
const _hoisted_23 = ["disabled"]
const _hoisted_24 = { class: "modal-vs-cancelar" }

import { ref, computed, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useComponentes } from '@/store/GestionComponentes'
import { useGestionVersiones } from '@/store/GestionVersiones'
import useModelo from '@/store/GestionModelo'
import { useGestionTipoComponente } from '@/store/GestionTipoComponente'
import { useGestionIndicadores } from '@/store/GestionIndicadores' 
import type Componente from '@/interfaces/Componente'
import type Indicador from '@/interfaces/Indicador'
import type TipoComponente from '@/interfaces/TipoComponente'
import MensajeConfirmacion from '@/components/MensajeConfirmacion.vue'
import ModificarComponentes from '@/components/ModificarComponentes.vue'
import LoadingOverlay from '@/components/LoadingOverlay.vue'
import FormularioIndicador from '@/components/FormularioIndicador.vue'
import MensajeFlotante from '@/components/MensajeFlotante.vue'
import VincularFormularioModal from '@/components/VincularFormularioModal.vue'
import CrearFormularioModal from '@/components/CrearFormularioModal.vue'
import ModificarFormularioModal from '@/components/ModificarFormularioModal.vue'
import { useGestionIndicadorInstrumentos } from '@/store/GestionIndicadorInstrumentos'
import { useGestionInstrumento } from '@/store/GestionInstrumentos'
import type Instrumento from '@/interfaces/Instrumetos'
import InstrumentosView from '@/views/InstrumentosView.vue'
import { limpiarNiveles } from '@/utils/nivelesHelper'
import { podarPorEnfoque, podarGruposVariante } from '@/utils/estructuraActiva'

interface ComponenteAplanado {
  ref: Componente
  nivel: number
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AgregarIndicadoresView',
  setup(__props) {

/**
 * Alta de indicadores sobre los aspectos de una versión.
 *
 * Un indicador se crea colgado de un aspecto, y un aspecto está activo en la
 * versión solo si tiene indicador en ella. Requiere la VERSIÓN en `edicion`.
 *
 * ── Enrutado ─────────────────────────────────────────────────────
 *   `/version/:id_version/indicadores` (AgregarIndicadores) — permiso `indicadores.crear`
 *
 * Vista enrutada. Obtiene sus datos a través de stores Pinia: no llama a `http`
 * ni a los servicios directamente.
 */

const route = useRoute()
const router = useRouter()
const store = useComponentes()
const versionStore = useGestionVersiones()
const modeloStore = useModelo()
const tipoStore = useGestionTipoComponente()
const indicadoresStore = useGestionIndicadores() 
const idVersion = Number(route.params.id_version ?? NaN)
const loading = ref(false)
const loadingMessage = ref('Cargando indicadores...')
const loadingAccion = ref(false)
const nombreModelo = ref('')
const nombreVersion = ref('')
const mensajeVisible = ref(false)
const mensajeTexto = ref('')
const mensajeTipo = ref<'positivo' | 'error'>('positivo')

function mostrarMensaje(texto: string, tipo: 'positivo' | 'error') {
  mensajeTexto.value = texto
  mensajeTipo.value = tipo
  mensajeVisible.value = true
}
const mostrarPanelVersus = ref(false)
const mostrarConfirmar = ref(false)
const mostrarAvanzarHistorico = ref(false)
const nivelesArray = ref<string[]>([])
const idComponenteRaiz = ref<number | null>(null)
const ultimosNivelesIniciales = ref<Componente[]>([])
const indicadorInstrumentoStore = useGestionIndicadorInstrumentos()
const instrumentosStore = useGestionInstrumento()
const componentesFallidos = ref<typeof ultimosNivelesIniciales.value>([])
const mostrarReintentoIndicadores = ref(false)
const mostrarConfirmarVolverHistorico = ref(false)
const mostrarConfirmarEliminar = ref(false)
const indicadorAEliminar = ref<Indicador | null>(null)
const mostrarConfirmarEliminarInstrumento = ref(false)
const instrumentoAEliminar = ref<Instrumento | null>(null)
const indicadorDelInstrumentoAEliminar = ref<Indicador | null>(null)
const mensajeEliminarInstrumento = ref('')

// Estados para modal de instrumentos
const mostrarModalInstrumento = ref(false)
const instrumentoIdTipoComponente = ref<number>(0)
const instrumentoIdIndicador = ref<number>(0)
const instrumentoIdInstrumento = ref<number | null>(null)

// Estado para modificar formulario de opinión
const mostrarModificarFormulario = ref(false)
const instrumentoIdParaModificar = ref<number | null>(null)

// Ruta jerárquica del indicador activo para VincularFormularioModal
const rutaParaVincular = ref<{ etiqueta: string; nombre: string }[]>([])

function construirRutaComponente(idComponente: number): { etiqueta: string; nombre: string }[] {
  const ruta: { etiqueta: string; nombre: string }[] = []
  let id: number | null | undefined = idComponente
  while (id != null) {
    const aplanado = componentesAplanados.value.find(c => c.ref.id_componente === id)
    if (!aplanado) break
    ruta.unshift({
      etiqueta: obtenerNumeracionJerarquica(aplanado.ref, aplanado.nivel),
      nombre: aplanado.ref.nombre
    })
    id = aplanado.ref.padre_id
  }
  return ruta
}

// Estado para modales de agregar/modificar
const tiposDisponibles = ref<TipoComponente[]>([])
const unidadesDisponibles = ref<{ id_unidad: number; nombre: string }[]>([])
const formulasDisponibles = ref<{ id_formula: number; nombre: string; clasificacion?: string }[]>([])
const nombresDisponibles = ref<{ id_nombre: number; nombre: string }[]>([])
const mostrarFormAgregar = ref(false)
// Formularios de opinión: crear uno suelto y vincularlo a un indicador
const mostrarCrearFormulario = ref(false)
const mostrarVincularFormulario = ref(false)
const indicadorParaVincular = ref<Indicador | null>(null)
const mostrarFormModificar = ref(false)
const padreSeleccionado = ref<Componente | null>(null)
const editandoIndicador = ref<Indicador | null>(null)

const componentesAplanados = ref<ComponenteAplanado[]>([])

function aplanarComponentes(arbol: Componente[], nivel = 0): ComponenteAplanado[] {
  const resultado: ComponenteAplanado[] = []
  for (const comp of arbol) {
    if (nivel > 0) resultado.push({ ref: comp, nivel })
    if ((comp.children?.length ?? 0) > 0) {
      resultado.push(...aplanarComponentes(comp.children!, nivel + 1))
    }
  }
  return resultado
}

function obtenerPadreRef(padreId: number | null | undefined): Componente | null {
  if (padreId == null) return null
  return componentesAplanados.value.find(c => c.ref.id_componente === padreId)?.ref ?? null
}

function obtenerNumeracionJerarquica(componente: Componente, _nivel: number): string {
  const aplanado = componentesAplanados.value.find(c => c.ref.id_componente === componente.id_componente)
  if (!aplanado) return ''

  const numeros: number[] = []
  let actual: ComponenteAplanado | null = aplanado

  while (actual && actual.nivel > 0) {
    const padre = obtenerPadreRef(actual.ref.padre_id)
    if (!padre) {
      const hermanos = componentesAplanados.value
        .filter(c => c.nivel === 1)
        .sort((a, b) => (a.ref.ordinal ?? '').localeCompare(b.ref.ordinal ?? '', undefined, { numeric: true }))
      const pos = hermanos.findIndex(h => h.ref.id_componente === actual!.ref.id_componente)
      numeros.unshift(pos + 1)
      break
    } else {
      const hermanosSorted = [...(padre.children ?? [])].sort((a, b) =>
        (a.ordinal ?? '').localeCompare(b.ordinal ?? '', undefined, { numeric: true })
      )
      const pos = hermanosSorted.findIndex(h => h.id_componente === actual!.ref.id_componente)
      numeros.unshift(pos + 1)
      actual = componentesAplanados.value.find(c => c.ref.id_componente === padre.id_componente) ?? null
    }
  }

  const numero = numeros.join('.')
  if (!numero) return ''
  const nombreNivel = nivelesArray.value[aplanado.nivel - 1] ?? `Nivel ${aplanado.nivel}`
  return `${nombreNivel} ${numero}`
}

function calcularProfundidad(nodo: Componente, nivel = 1): number {
  if (!nodo.children || nodo.children.length === 0) return nivel
  return Math.max(...nodo.children.map(h => calcularProfundidad(h, nivel + 1)))
}

function obtenerUltimoNivel(nodo: Componente, nivelActual = 1, nivelMaximo: number): Componente[] {
  if (nivelActual === nivelMaximo) return [nodo]
  if (!nodo.children) return []
  return nodo.children.flatMap(h => obtenerUltimoNivel(h, nivelActual + 1, nivelMaximo))
}


// Carga inicial
onMounted(async () => {
  loading.value = true
  try {
    // Versión y modelo
    const version = await versionStore.getVersionById(idVersion)
    nombreVersion.value = version?.nombre ?? ''
    if (version?.id_modelo) {
      const modelo = await modeloStore.getModeloById(version.id_modelo)
      nombreModelo.value = modelo?.nombre ?? ''
      if (modelo?.niveles) {
        nivelesArray.value = limpiarNiveles(modelo.niveles)
      }
    }

    // Raíz y árbol de componentes — C-01: componentes cuelgan del modelo, no de la versión
    const idModelo = version?.id_modelo
    const raiz = idModelo ? await store.cargarRaizPorModelo(idModelo) : null
    if (raiz) {
      idComponenteRaiz.value = raiz.id_componente ?? null
      const ok = await store.cargarArbolDesdeRaiz(idComponenteRaiz.value!, nivelesArray.value)
      if (ok) {
        // Oculta las variantes de otro enfoque y colapsa grupos de variante:
        // de cada grupo_variante solo queda el representante adecuado para la versión.
        const arbolPodado = podarGruposVariante(
          podarPorEnfoque(store.componentes, version?.enfoque),
          version?.enfoque
        )
        componentesAplanados.value = aplanarComponentes(arbolPodado)
        const raizCompleta = arbolPodado.find(c => c.id_componente === idComponenteRaiz.value)
        if (raizCompleta) {
          const nivelMax = calcularProfundidad(raizCompleta)
          ultimosNivelesIniciales.value = obtenerUltimoNivel(raizCompleta, 1, nivelMax)
        }
      }
    }

    const [tipos] = await Promise.all([
      tipoStore.getTipos(),
      indicadoresStore.cargarTodos(),
      instrumentosStore.cargarTodos(),
      indicadorInstrumentoStore.getRelaciones()
    ])
    tiposDisponibles.value = tipos ?? []

// Unidades únicas
const unidadesUnicas = Array.from(
  new Set(
    indicadoresStore.indicadores
      .map(i => i.unidades)
      .filter((v): v is string => typeof v === 'string' && v.trim().length > 0)
      .map(v => v.trim())
  )
)

unidadesDisponibles.value = unidadesUnicas.map((nombre, idx) => ({
  id_unidad: idx + 1,
  nombre
}))

// Fórmulas únicas agrupadas por clasificación de indicador
const formulasPorClasif = new Map<string, { id_formula: number; nombre: string; clasificacion: string }>()
let idxF = 0
for (const ind of indicadoresStore.indicadores) {
  if (!ind.formula?.trim()) continue
  const nombre = ind.formula.trim()
  const tipo = tiposDisponibles.value.find(t => t.id_tipo_componente === ind.id_tipo_componente)
  const nombreTipo = (tipo?.nombre ?? '').toLowerCase()
  const clasificacion = /document/.test(nombreTipo)
    ? 'documental'
    : /cuantitativ/.test(nombreTipo)
    ? 'cuantitativa'
    : /opini/.test(nombreTipo)
    ? 'opinion'
    : 'otro'
  const key = `${clasificacion}::${nombre.toLowerCase()}`
  if (!formulasPorClasif.has(key)) {
    formulasPorClasif.set(key, { id_formula: ++idxF, nombre, clasificacion })
  }
}
formulasDisponibles.value = [...formulasPorClasif.values()]

const nombresUnicos = Array.from(
  new Set(
    indicadoresStore.indicadores
      .filter(i => i.unidades?.trim() || i.formula?.trim())
      .map(i => (i.enunciado ?? i.nombre ?? '').trim())
      .filter(v => v.length > 0)
  )
)
nombresDisponibles.value = nombresUnicos.map((nombre, idx) => ({
  id_nombre: idx + 1,
  nombre
}))

  } catch (e: any) {
    mostrarMensaje(e?.message || 'Error al cargar datos iniciales.', 'error')
  } finally {
    loading.value = false
  }

  // Mostrar notificación si se viene de crear/modificar un instrumento
  const mensajeInstrumento = sessionStorage.getItem('instrumento_creado')
  if (mensajeInstrumento) {
    mostrarMensaje(mensajeInstrumento, 'positivo')
    sessionStorage.removeItem('instrumento_creado')
  }

  // Mostrar panel versus si no hay indicadores para esta versión
  const indicadoresDeLaVersion = indicadoresStore.indicadores.filter(i => i.id_version === idVersion)
  if (indicadoresDeLaVersion.length === 0) {
    mostrarPanelVersus.value = true
  }
})

const filtroTipo = ref<'' | 'documental' | 'cuantitativa' | 'opinion'>('')

function nombreEsTipo(nombre: string | undefined, filtro: string): boolean {
  if (!nombre) return false
  if (filtro === 'documental') return /document/i.test(nombre)
  if (filtro === 'cuantitativa') return /cuantitativ/i.test(nombre)
  if (filtro === 'opinion') return /opini/i.test(nombre)
  return true
}

// incluye indicadores filtrados por id_componente
const nodosConIndicadores = computed(() => {
  return ultimosNivelesIniciales.value.map(nodo => ({
    ...nodo,
    indicadores: indicadoresStore.indicadores.filter(i => i.id_componente === nodo.id_componente && i.id_version === idVersion)
  }))
})

const nodosConIndicadoresFiltrados = computed(() => {
  if (!filtroTipo.value) return nodosConIndicadores.value
  return nodosConIndicadores.value
    .map(nodo => ({
      ...nodo,
      indicadores: nodo.indicadores.filter(ind => {
        const tipo = tiposDisponibles.value.find(t => t.id_tipo_componente === ind.id_tipo_componente)
        return nombreEsTipo(tipo?.nombre, filtroTipo.value)
      })
    }))
    .filter(nodo => nodo.indicadores.length > 0)
})

function instrumentosPorIndicadorFn(id_indicador: number): Instrumento[] {
  const relaciones = indicadorInstrumentoStore.relaciones.filter(r => r.id_indicador === id_indicador)
  return relaciones
    .map(r => instrumentosStore.instrumentos.find(i => i.id_instrumento === r.id_instrumento))
    .filter((i): i is Instrumento => !!i)
}

const esNodoIndicador = (c: any) => !!c.indicadores

// Abrir modal para agregar indicador
function onAgregarIndicador(payload: { padre: Componente; nivel: number }) {
  padreSeleccionado.value = payload.padre
  mostrarFormAgregar.value = true
}

function cancelarAgregar() {
  padreSeleccionado.value = null
  mostrarFormAgregar.value = false
}

async function onAceptarAgregar(payload: {
  tipoIndicadorId: number | ''
  nuevoTipoNombre: string
  nombreIndicador: string
  unidadIndicadorId: string
  nuevaUnidadNombre: string
  formulaIndicadorId: string
  nuevaFormulaNombre: string
  descripcionIndicador: string
}) {
  if (!padreSeleccionado.value) return
  try {
    loadingAccion.value = true
    const indicador = await guardarIndicador(payload, padreSeleccionado.value)
    if (!indicador) return

    const tipoAuto = detectarTipoAuto(indicador.id_tipo_componente)
    if (tipoAuto) {
      try {
        await crearInstrumentoAutomatico(indicador, tipoAuto)
        mostrarMensaje('Indicador e instrumento creados correctamente.', 'positivo')
      } catch {
        mostrarMensaje('Indicador creado, pero no se pudo generar el instrumento automáticamente.', 'error')
      }
    } else {
      mostrarMensaje('Indicador agregado correctamente.', 'positivo')
    }
    cancelarAgregar()
  } catch (e: any) {
    mostrarMensaje(e?.message || 'Error inesperado al agregar indicador.', 'error')
  } finally {
    loadingAccion.value = false
  }
}

// Abrir modal para modificar indicador
function onModificarIndicador(indicador: Indicador) {
  editandoIndicador.value = indicador
  // Buscar el componente padre
  padreSeleccionado.value = ultimosNivelesIniciales.value.find(
    n => n.id_componente === indicador.id_componente
  ) ?? null
  mostrarFormModificar.value = true
}

function cancelarModificar() {
  editandoIndicador.value = null
  padreSeleccionado.value = null
  mostrarFormModificar.value = false
}

async function onAceptarModificar(payload: {
  tipoIndicadorId: number | ''
  nuevoTipoNombre: string
  nombreIndicador: string
  unidadIndicadorId: string
  nuevaUnidadNombre: string
  formulaIndicadorId: string
  nuevaFormulaNombre: string
  descripcionIndicador: string
}) {
  if (!editandoIndicador.value) return
  try {
    loadingAccion.value = true
    const result = await actualizarIndicador(payload, editandoIndicador.value)
    if (result) {
      mostrarMensaje('Indicador modificado correctamente.', 'positivo')
      cancelarModificar()
    }
  } catch (e: any) {
    mostrarMensaje(e?.message || 'Error inesperado al modificar indicador.', 'error')
  } finally {
    loadingAccion.value = false
  }
}

// Lógica compartida para resolver tipo/unidad/fórmula
async function resolverPayload(payload: {
  tipoIndicadorId: number | ''
  nuevoTipoNombre: string
  nombreIndicador: string
  unidadIndicadorId: string
  nuevaUnidadNombre: string
  formulaIndicadorId: string
  nuevaFormulaNombre: string
  descripcionIndicador: string
}, peso: number | null) {
  let tipoId = payload.tipoIndicadorId as number
  let unidadNombre = ''
  let formulaNombre = ''

  // Crear nuevo tipo si corresponde
  if (payload.nuevoTipoNombre.trim()) {
    const nuevoTipo = await tipoStore.crearTipo({
      nombre: payload.nuevoTipoNombre.trim(),
      ponderacion: peso
    })
    if (!nuevoTipo?.id_tipo_componente) {
      mostrarMensaje('Error al crear nuevo tipo de indicador.', 'error')
      return null
    }
    tipoId = nuevoTipo.id_tipo_componente
    tiposDisponibles.value.push(nuevoTipo)
  }

  // Resolver Unidad
  if (payload.nuevaUnidadNombre.trim()) {
    unidadNombre = payload.nuevaUnidadNombre.trim()
    unidadesDisponibles.value.push({ id_unidad: Date.now(), nombre: unidadNombre })
  } else {
    unidadNombre = payload.unidadIndicadorId || ''
  }

  // Resolver Fórmula
  if (payload.nuevaFormulaNombre.trim()) {
    formulaNombre = payload.nuevaFormulaNombre.trim()
    formulasDisponibles.value.push({ id_formula: Date.now(), nombre: formulaNombre })
  } else {
    formulaNombre = payload.formulaIndicadorId || ''
  }

  return {
    id_tipo_componente: tipoId,
    enunciado: payload.nombreIndicador,
    unidades: unidadNombre,
    descripcion: payload.descripcionIndicador || null,
    formula: formulaNombre,
    fuente_informacion: null,
    peso_opinion: peso
  }
}

async function guardarIndicador(payload: Parameters<typeof resolverPayload>[0], padre: Componente): Promise<import('@/interfaces/Indicador').default | false> {
  const datos = await resolverPayload(payload, padre.peso ?? null)
  if (!datos) return false

  const nuevo = await indicadoresStore.crear(padre.id_componente!, { ...datos, id_version: idVersion })
  if (!nuevo) {
    mostrarMensaje('Error al crear indicador.', 'error')
    return false
  }
  return nuevo
}

function detectarTipoAuto(tipoId: number): 'documental' | 'cuantitativa' | null {
  const tipo = tiposDisponibles.value.find(t => t.id_tipo_componente === tipoId)
  const nombre = tipo?.nombre ?? tipo?.tipo ?? ''
  if (nombreEsTipo(nombre, 'documental')) return 'documental'
  if (nombreEsTipo(nombre, 'cuantitativa')) return 'cuantitativa'
  return null
}

async function crearInstrumentoAutomatico(
  indicador: import('@/interfaces/Indicador').default,
  tipo: 'documental' | 'cuantitativa'
): Promise<void> {
  const herramienta = tipo === 'documental'
    ? 'Ficha de revisión Documental'
    : 'Ficha de revisión de indicadores Estadísticos'

  const nuevoInstrumento = await instrumentosStore.crearInstrumento({
    herramienta,
    descripcion: herramienta,
    id_tipo_componente: indicador.id_tipo_componente
  })
  if (!nuevoInstrumento?.id_instrumento || !indicador.id_indicador) return

  await indicadorInstrumentoStore.crearRelacion({
    id_indicador: indicador.id_indicador,
    id_instrumento: nuevoInstrumento.id_instrumento
  })
}

async function actualizarIndicador(payload: Parameters<typeof resolverPayload>[0], indicador: Indicador) {
  const datos = await resolverPayload(payload, padreSeleccionado.value?.peso ?? null)
  if (!datos) return false

  const actualizado = await indicadoresStore.actualizarIndicador(indicador.id_indicador!, datos)
  if (!actualizado) {
    mostrarMensaje('Error al modificar indicador.', 'error')
    return false
  }
  return true
}

// Eventos de modificar/eliminar
function onEliminarIndicador(indicador: Indicador) {
  indicadorAEliminar.value = indicador
  mostrarConfirmarEliminar.value = true
}

async function confirmarEliminarIndicador() {
  if (!indicadorAEliminar.value) return

  try {
    loading.value = true
    const ok = await indicadoresStore.eliminar(indicadorAEliminar.value.id_indicador!)

    mostrarMensaje(
      ok ? 'Indicador e instrumentos asociados eliminados correctamente.' : 'No se pudo eliminar el indicador.',
      ok ? 'positivo' : 'error'
    )
  } catch (e: any) {
    mostrarMensaje(e?.message || 'Error inesperado al eliminar indicador.', 'error')
  } finally {
    mostrarConfirmarEliminar.value = false
    indicadorAEliminar.value = null
    loading.value = false
  }
}

// Navegar y completar modelo
function salir() {
  router.push({ name: 'ListaVersiones', query: { modo: 'indicadores' } })
}

function elegirAgregarIndicadores() {
  mostrarPanelVersus.value = false
}

async function elegirSinIndicadores(objetivo?: typeof ultimosNivelesIniciales.value) {
  if (loadingAccion.value) return
  loadingAccion.value = true
  loadingMessage.value = 'Generando indicadores...'
  loading.value = true
  const pendientes = objetivo ?? ultimosNivelesIniciales.value
  try {
    const tipoId = tiposDisponibles.value[0]?.id_tipo_componente ?? 1

    // Filtrar los que ya tienen indicador (sin HTTP)
    const compsSinIndicador = pendientes.filter(comp =>
      !indicadoresStore.indicadores.some(
        i => i.id_componente === comp.id_componente && i.id_version === idVersion
      )
    )

    // Crear todos en paralelo
    const resultados = await Promise.allSettled(
      compsSinIndicador.map(comp => indicadoresStore.crear(comp.id_componente!, {
        id_version: idVersion,
        id_tipo_componente: tipoId,
        enunciado: comp.nombre,
        formula: null,
        unidades: null,
        fuente_informacion: null,
        descripcion: null,
        peso_opinion: null
      }))
    )

    const fallidos = compsSinIndicador.filter((_, idx) => {
      const r = resultados[idx]
      return r.status === 'rejected' || !r.value
    })

    if (fallidos.length > 0) {
      componentesFallidos.value = fallidos
      mostrarReintentoIndicadores.value = true
      return
    }

    router.push({ name: 'ProcesoAutoevaluacion' })
  } catch (e: any) {
    mostrarMensaje(e?.message || 'Error al generar indicadores por defecto.', 'error')
  } finally {
    loadingAccion.value = false
    loading.value = false
  }
}

async function avanzarSinGenerar() {
  if (loadingAccion.value) return
  loadingAccion.value = true
  mostrarConfirmarVolverHistorico.value = false
  try {
    router.push({ name: 'ProcesoAutoevaluacion' })
  } catch (e: any) {
    mostrarMensaje(e?.message || 'Error al avanzar.', 'error')
  } finally {
    loadingAccion.value = false
  }
}

// Validar que el modelo cumpla los requisitos mínimos
function validarModeloCompleto(): { valido: boolean; mensaje: string } {
  // Verificar que cada componente del último nivel tenga al menos un indicador
  const componentesSinIndicadores: string[] = []
  const indicadoresSinInstrumentos: string[] = []

  for (const nodo of ultimosNivelesIniciales.value) {
    // Obtener los indicadores de este componente
    const indicadores = indicadoresStore.indicadores.filter(
      i => i.id_componente === nodo.id_componente && i.id_version === idVersion
    )

    // Si no tiene indicadores, agregarlo a la lista
    if (indicadores.length === 0) {
      componentesSinIndicadores.push(nodo.nombre)
      continue
    }

    // Verificar que cada indicador tenga al menos un instrumento
    for (const indicador of indicadores) {
      const instrumentos = instrumentosPorIndicadorFn(indicador.id_indicador!)
      if (instrumentos.length === 0) {
        indicadoresSinInstrumentos.push(`${nodo.nombre} > ${indicador.enunciado ?? indicador.nombre}`)
      }
    }
  }

  if (componentesSinIndicadores.length === 0 && indicadoresSinInstrumentos.length === 0) {
    return { valido: true, mensaje: '' }
  }

  const mensaje = 'Para completar el modelo, todos los componentes deben tener al menos un indicador y todos los indicadores al menos un instrumento.'

  return { valido: false, mensaje }
}

// Validar y mostrar confirmación para completar modelo
function validarYCompletar() {
  const validacion = validarModeloCompleto()

  if (!validacion.valido) {
    mostrarAvanzarHistorico.value = true
    return
  }

  // Si es válido, mostrar confirmación de completar modelo
  mostrarConfirmar.value = true
}

async function CompletarModelo() {
  if (!Number.isFinite(idVersion) || idVersion <= 0) {
    mostrarMensaje('ID de versión inválida.', 'error')
    return
  }
  mostrarMensaje('Modelo guardado exitosamente.', 'positivo')
  router.push({ name: 'ListaVersiones' })
}

// agregar instrumento
async function onFormularioCreado(mensaje: string) {
  mostrarMensaje(mensaje, 'positivo')
  // El formulario nuevo debe aparecer al vincular, así que se refresca la lista.
  await instrumentosStore.cargarTodos()
}

function onVincularFormulario(indicador: Indicador) {
  indicadorParaVincular.value = indicador
  rutaParaVincular.value = indicador.id_componente
    ? construirRutaComponente(indicador.id_componente)
    : []
  mostrarVincularFormulario.value = true
}

async function onFormularioVinculado(mensaje: string) {
  mostrarMensaje(mensaje, 'positivo')
  // La fila del instrumento sale del PIVOTE indicador-instrumento, así que sin
  // recargarlo el formulario recién vinculado no aparecía hasta refrescar la
  // página entera.
  await Promise.all([
    indicadoresStore.cargarTodos(),
    instrumentosStore.cargarTodos(),
    indicadorInstrumentoStore.getRelaciones()
  ])
}

function onAgregarInstrumento(indicador?: Indicador) {
  if (!indicador) {
    console.warn('No se recibió indicador en onAgregarInstrumento')
    return
  }
  instrumentoIdTipoComponente.value = indicador.id_tipo_componente
  instrumentoIdIndicador.value = indicador.id_indicador!
  instrumentoIdInstrumento.value = null
  mostrarModalInstrumento.value = true
}

// modificar instrumento
function onModificarInstrumento(instrumento: Instrumento) {
  if (instrumento.modalidad != null) {
    instrumentoIdParaModificar.value = instrumento.id_instrumento ?? null
    mostrarModificarFormulario.value = true
    return
  }
  const relacion = indicadorInstrumentoStore.relaciones.find(
    r => r.id_instrumento === instrumento.id_instrumento
  )
  instrumentoIdTipoComponente.value = instrumento.id_tipo_componente
  instrumentoIdIndicador.value = relacion?.id_indicador ?? 0
  instrumentoIdInstrumento.value = instrumento.id_instrumento ?? null
  mostrarModalInstrumento.value = true
}

async function onFormularioModificado(mensaje: string) {
  mostrarMensaje(mensaje, 'positivo')
  mostrarModificarFormulario.value = false
  try {
    await Promise.all([
      instrumentosStore.cargarTodos(),
      indicadorInstrumentoStore.getRelaciones()
    ])
  } catch { /* ignorar */ }
}

// cerrar modal de instrumentos y recargar
async function cerrarModalInstrumento() {
  mostrarModalInstrumento.value = false
  instrumentoIdInstrumento.value = null

  // Mostrar el mensaje antes de la recarga para que aparezca inmediatamente
  const mensajeInstrumento = sessionStorage.getItem('instrumento_creado')
  if (mensajeInstrumento) {
    mostrarMensaje(mensajeInstrumento, 'positivo')
    sessionStorage.removeItem('instrumento_creado')
  }

  try {
    await Promise.all([
      instrumentosStore.cargarTodos(),
      indicadorInstrumentoStore.getRelaciones()
    ])
  } catch (err: any) {
    console.error('Error al recargar datos:', err)
  }
}

// desvincular instrumento - mostrar confirmación
function onEliminarInstrumento(payload: { instrumento: Instrumento; indicador: Indicador }) {
  instrumentoAEliminar.value = payload.instrumento
  indicadorDelInstrumentoAEliminar.value = payload.indicador
  mensajeEliminarInstrumento.value = '¿Desea desvincular el instrumento de este indicador? El instrumento permanecerá en el sistema.'
  mostrarConfirmarEliminarInstrumento.value = true
}

// confirmar desvinculación de instrumento
async function confirmarEliminarInstrumento() {
  const instrumento = instrumentoAEliminar.value
  const indicador = indicadorDelInstrumentoAEliminar.value
  if (!instrumento?.id_instrumento || !indicador?.id_indicador) return

  const relacion = indicadorInstrumentoStore.relaciones.find(
    r => r.id_instrumento === instrumento.id_instrumento && r.id_indicador === indicador.id_indicador
  )
  if (!relacion?.id) {
    mostrarMensaje('No se encontró la relación entre el indicador y el instrumento.', 'error')
    mostrarConfirmarEliminarInstrumento.value = false
    return
  }

  try {
    loading.value = true
    const ok = await indicadorInstrumentoStore.eliminarRelacion(relacion.id)

    if (ok) {
      mostrarMensaje('Instrumento desvinculado correctamente.', 'positivo')
      await indicadorInstrumentoStore.getRelaciones()
    } else {
      mostrarMensaje('No se pudo desvincular el instrumento.', 'error')
    }
  } catch (e: any) {
    mostrarMensaje(e?.message || 'Error inesperado al desvincular instrumento.', 'error')
  } finally {
    mostrarConfirmarEliminarInstrumento.value = false
    instrumentoAEliminar.value = null
    indicadorDelInstrumentoAEliminar.value = null
    loading.value = false
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(LoadingOverlay, {
      visible: loading.value,
      message: loadingMessage.value
    }, null, 8, ["visible", "message"]),
    (!loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (mostrarPanelVersus.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _cache[24] || (_cache[24] = _createElementVNode("div", { class: "vs-encabezado" }, [
                  _createElementVNode("h1", null, "¿Qué deseas hacer?"),
                  _createElementVNode("p", null, "Selecciona una de las dos opciones para continuar")
                ], -1)),
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", { class: "vs-card vs-card--azul" }, [
                    _cache[20] || (_cache[20] = _createElementVNode("h2", null, "Agregar indicadores e instrumentos", -1)),
                    _cache[21] || (_cache[21] = _createElementVNode("p", { class: "vs-desc" }, "Acceda a la vista para configurar manualmente los indicadores e instrumentos del modelo.", -1)),
                    _createElementVNode("button", {
                      class: "vs-btn vs-btn--azul",
                      type: "button",
                      onClick: elegirAgregarIndicadores
                    }, "Aceptar")
                  ]),
                  _createElementVNode("div", _hoisted_5, [
                    _cache[22] || (_cache[22] = _createElementVNode("h2", null, "Modelo Histórico", -1)),
                    _cache[23] || (_cache[23] = _createElementVNode("p", { class: "vs-desc" }, "El modelo ya tiene su estructura definida. Al aceptar, avanzará directamente al proceso de calificación sin necesidad de agregar indicadores ni instrumentos.", -1)),
                    _createElementVNode("button", {
                      class: "vs-btn vs-btn--amarillo",
                      type: "button",
                      onClick: _cache[0] || (_cache[0] = () => elegirSinIndicadores()),
                      disabled: loadingAccion.value
                    }, _toDisplayString(loadingAccion.value ? 'Generando...' : 'Aceptar'), 9, _hoisted_6)
                  ])
                ])
              ]))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", null, [
                    _cache[25] || (_cache[25] = _createElementVNode("h1", null, "Agregar Indicadores", -1)),
                    (nombreVersion.value)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(nombreVersion.value), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("button", {
                      class: "btn salir",
                      disabled: loadingAccion.value || loading.value,
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (mostrarConfirmarVolverHistorico.value = true))
                    }, " Volver Histórico ", 8, _hoisted_10),
                    _createElementVNode("button", {
                      class: "btn guardar",
                      disabled: loadingAccion.value || loading.value,
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (mostrarCrearFormulario.value = true))
                    }, " ➕ Crear Formulario ", 8, _hoisted_11),
                    _createElementVNode("button", {
                      class: "btn guardar",
                      disabled: loadingAccion.value || loading.value,
                      onClick: _withModifiers(validarYCompletar, ["prevent"])
                    }, _toDisplayString(loadingAccion.value ? 'Completando versión...' : 'Completar Modelo'), 9, _hoisted_12)
                  ])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("button", {
                    class: _normalizeClass(["btn-filtro", { activo: filtroTipo.value === '' }]),
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (filtroTipo.value = ''))
                  }, "Todos", 2),
                  _createElementVNode("button", {
                    class: _normalizeClass(["btn-filtro", { activo: filtroTipo.value === 'documental' }]),
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (filtroTipo.value = 'documental'))
                  }, "Documental", 2),
                  _createElementVNode("button", {
                    class: _normalizeClass(["btn-filtro", { activo: filtroTipo.value === 'cuantitativa' }]),
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (filtroTipo.value = 'cuantitativa'))
                  }, "Cuantitativa", 2),
                  _createElementVNode("button", {
                    class: _normalizeClass(["btn-filtro", { activo: filtroTipo.value === 'opinion' }]),
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (filtroTipo.value = 'opinion'))
                  }, "Opinión", 2)
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(ModificarComponentes, {
                    componentes: nodosConIndicadoresFiltrados.value,
                    idComponenteRaiz: idComponenteRaiz.value,
                    esIndicadores: true,
                    esIndicadorFn: esNodoIndicador,
                    instrumentosPorIndicadorFn: instrumentosPorIndicadorFn,
                    niveles: nivelesArray.value,
                    obtenerNumeracion: obtenerNumeracionJerarquica,
                    loading: loadingAccion.value || loading.value,
                    onModificarIndicador: onModificarIndicador,
                    onEliminarIndicador: onEliminarIndicador,
                    onAgregarHijo: onAgregarIndicador,
                    onAgregarInstrumento: onAgregarInstrumento,
                    onVincularFormulario: onVincularFormulario,
                    onModificarInstrumento: onModificarInstrumento,
                    onEliminarInstrumento: onEliminarInstrumento
                  }, null, 8, ["componentes", "idComponenteRaiz", "niveles", "loading"]),
                  _createVNode(FormularioIndicador, {
                    visible: mostrarFormAgregar.value,
                    modo: "agregar",
                    loading: loadingAccion.value,
                    tiposDisponibles: tiposDisponibles.value,
                    unidadesDisponibles: unidadesDisponibles.value,
                    formulasDisponibles: formulasDisponibles.value,
                    nombresDisponibles: nombresDisponibles.value,
                    onAceptar: onAceptarAgregar,
                    onCancelar: cancelarAgregar
                  }, null, 8, ["visible", "loading", "tiposDisponibles", "unidadesDisponibles", "formulasDisponibles", "nombresDisponibles"]),
                  _createVNode(FormularioIndicador, {
                    visible: mostrarFormModificar.value,
                    modo: "modificar",
                    loading: loadingAccion.value,
                    tiposDisponibles: tiposDisponibles.value,
                    unidadesDisponibles: unidadesDisponibles.value,
                    formulasDisponibles: formulasDisponibles.value,
                    nombresDisponibles: nombresDisponibles.value,
                    tipoInicial: editandoIndicador.value?.id_tipo_componente ?? '',
                    nombreInicial: editandoIndicador.value?.enunciado ?? editandoIndicador.value?.nombre ?? '',
                    unidadInicial: editandoIndicador.value?.unidades ?? '',
                    formulaInicial: editandoIndicador.value?.formula ?? '',
                    descripcionInicial: editandoIndicador.value?.descripcion ?? '',
                    onAceptar: onAceptarModificar,
                    onCancelar: cancelarModificar
                  }, null, 8, ["visible", "loading", "tiposDisponibles", "unidadesDisponibles", "formulasDisponibles", "nombresDisponibles", "tipoInicial", "nombreInicial", "unidadInicial", "formulaInicial", "descripcionInicial"]),
                  _createVNode(MensajeConfirmacion, {
                    visible: mostrarConfirmarEliminar.value,
                    title: "Confirmar eliminación",
                    message: "Al eliminar el indicador también se eliminarán todos los instrumentos asociados y la tabla de relación. ¿Desea continuar?",
                    confirmText: "Eliminar",
                    cancelText: "Cancelar",
                    confirmLoading: loading.value,
                    onConfirm: confirmarEliminarIndicador,
                    onCancel: _cache[7] || (_cache[7] = ($event: any) => (mostrarConfirmarEliminar.value = false))
                  }, null, 8, ["visible", "confirmLoading"]),
                  _createVNode(MensajeConfirmacion, {
                    visible: mostrarConfirmarEliminarInstrumento.value,
                    title: "Confirmar desvinculación de instrumento",
                    message: mensajeEliminarInstrumento.value,
                    confirmText: "Desvincular",
                    cancelText: "Cancelar",
                    confirmLoading: loading.value,
                    onConfirm: confirmarEliminarInstrumento,
                    onCancel: _cache[8] || (_cache[8] = ($event: any) => (mostrarConfirmarEliminarInstrumento.value = false))
                  }, null, 8, ["visible", "message", "confirmLoading"])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("button", {
                    class: "btn salir",
                    onClick: salir
                  }, "Salir"),
                  _createElementVNode("button", {
                    class: "btn guardar",
                    disabled: loadingAccion.value || loading.value,
                    onClick: _withModifiers(validarYCompletar, ["prevent"])
                  }, _toDisplayString(loadingAccion.value ? 'Completando versión...' : 'Completar Modelo'), 9, _hoisted_16),
                  _createVNode(MensajeConfirmacion, {
                    visible: mostrarAvanzarHistorico.value,
                    title: "Validación incompleta",
                    message: "El modelo no cumple todos los requisitos. ¿Desea completarlo de todos modos?",
                    confirmText: "Avanzar de todos modos",
                    cancelText: "Cancelar",
                    confirmLoading: loadingAccion.value,
                    onConfirm: _cache[9] || (_cache[9] = ($event: any) => {mostrarAvanzarHistorico.value = false; CompletarModelo()}),
                    onCancel: _cache[10] || (_cache[10] = ($event: any) => (mostrarAvanzarHistorico.value = false))
                  }, null, 8, ["visible", "confirmLoading"]),
                  _createVNode(MensajeConfirmacion, {
                    visible: mostrarConfirmar.value,
                    title: "Confirmar acción",
                    message: "Al completar el modelo, la versión quedará disponible para ser asignada a nuevos procesos de autoevaluación. ¿Desea continuar?",
                    confirmText: "Aceptar",
                    cancelText: "Cerrar",
                    confirmLoading: loadingAccion.value,
                    onConfirm: CompletarModelo,
                    onCancel: _cache[11] || (_cache[11] = ($event: any) => (mostrarConfirmar.value = false))
                  }, null, 8, ["visible", "confirmLoading"])
                ])
              ], 64))
        ]))
      : _createCommentVNode("", true),
    _createVNode(InstrumentosView, {
      visible: mostrarModalInstrumento.value,
      idTipoComponente: instrumentoIdTipoComponente.value,
      idIndicador: instrumentoIdIndicador.value,
      idInstrumento: instrumentoIdInstrumento.value,
      onCerrar: cerrarModalInstrumento
    }, null, 8, ["visible", "idTipoComponente", "idIndicador", "idInstrumento"]),
    _createVNode(MensajeConfirmacion, {
      visible: mostrarReintentoIndicadores.value,
      title: "Indicadores incompletos",
      message: `No se pudo generar indicador para ${componentesFallidos.value.length} componente(s): ${componentesFallidos.value.map(c => c.nombre).join(', ')}. ¿Desea volver a intentarlo?`,
      confirmText: "Reintentar",
      cancelText: "Cancelar",
      confirmLoading: loadingAccion.value,
      onConfirm: _cache[12] || (_cache[12] = ($event: any) => {mostrarReintentoIndicadores.value = false; elegirSinIndicadores(componentesFallidos.value)}),
      onCancel: _cache[13] || (_cache[13] = ($event: any) => (mostrarReintentoIndicadores.value = false))
    }, null, 8, ["visible", "message", "confirmLoading"]),
    (mostrarConfirmarVolverHistorico.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _cache[30] || (_cache[30] = _createElementVNode("div", { class: "vs-encabezado" }, [
              _createElementVNode("h1", null, "¿Cómo desea proceder?"),
              _createElementVNode("p", null, "Selecciona una de las opciones para continuar")
            ], -1)),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _cache[26] || (_cache[26] = _createElementVNode("h2", null, "Volver Histórico", -1)),
                _cache[27] || (_cache[27] = _createElementVNode("p", { class: "vs-desc" }, "Al volver a modelo histórico se procederá a preparar la versión para que se pueda iniciar un proceso y subir la calificación de cada aspecto.", -1)),
                _createElementVNode("button", {
                  class: "vs-btn vs-btn--azul",
                  disabled: loadingAccion.value,
                  onClick: _cache[14] || (_cache[14] = ($event: any) => {mostrarConfirmarVolverHistorico.value = false; elegirSinIndicadores()})
                }, _toDisplayString(loadingAccion.value ? 'Generando...' : 'Aceptar'), 9, _hoisted_21)
              ]),
              _createElementVNode("div", _hoisted_22, [
                _cache[28] || (_cache[28] = _createElementVNode("h2", null, "Dejar como está", -1)),
                _cache[29] || (_cache[29] = _createElementVNode("p", { class: "vs-desc" }, "Esta opción vuelve el modelo histórico pero los aspectos que no tengan un indicador no se agregarán para su calificación.", -1)),
                _createElementVNode("button", {
                  class: "vs-btn vs-btn--amarillo",
                  disabled: loadingAccion.value,
                  onClick: avanzarSinGenerar
                }, " Dejar como está y avanzar ", 8, _hoisted_23)
              ])
            ]),
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("button", {
                class: "btn salir",
                onClick: _cache[15] || (_cache[15] = ($event: any) => (mostrarConfirmarVolverHistorico.value = false))
              }, "Cancelar")
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(CrearFormularioModal, {
      visible: mostrarCrearFormulario.value,
      onCerrar: _cache[16] || (_cache[16] = ($event: any) => (mostrarCrearFormulario.value = false)),
      onCreado: onFormularioCreado
    }, null, 8, ["visible"]),
    _createVNode(ModificarFormularioModal, {
      visible: mostrarModificarFormulario.value,
      idInstrumento: instrumentoIdParaModificar.value,
      onCerrar: _cache[17] || (_cache[17] = ($event: any) => (mostrarModificarFormulario.value = false)),
      onGuardado: onFormularioModificado
    }, null, 8, ["visible", "idInstrumento"]),
    _createVNode(VincularFormularioModal, {
      visible: mostrarVincularFormulario.value,
      idIndicador: indicadorParaVincular.value?.id_indicador ?? null,
      nombreIndicador: indicadorParaVincular.value?.enunciado ?? null,
      ruta: rutaParaVincular.value,
      onCerrar: _cache[18] || (_cache[18] = ($event: any) => (mostrarVincularFormulario.value = false)),
      onVinculado: onFormularioVinculado
    }, null, 8, ["visible", "idIndicador", "nombreIndicador", "ruta"]),
    _createVNode(MensajeFlotante, {
      visible: mensajeVisible.value,
      mensaje: mensajeTexto.value,
      tipo: mensajeTipo.value,
      onCerrar: _cache[19] || (_cache[19] = ($event: any) => (mensajeVisible.value = false))
    }, null, 8, ["visible", "mensaje", "tipo"])
  ]))
}
}

})